import React, { useContext, useState, useEffect } from 'react';
import axiosInstance from '../../axiosConfig';
import '../../styles/Support.css';
import { AuthContext } from '../../contexts/AuthContext';
import AdminTicketManagement from './AdminTicketManagement';
import Notification from '../notification/Notification'; // Correct import
import { format } from 'date-fns';
//import { Circles } from 'react-loader-spinner'; // Importing the loader component
import ResumeSkeleton from '../Loading/ResumeSkeleton';

const Pagination = ({ ticketsPerPage, totalTickets, paginate }) => {
    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(totalTickets / ticketsPerPage); i++) {
        pageNumbers.push(i);
    }

    return (
        <nav>
            <ul className="pagination">
                {pageNumbers?.map(number => (
                    <li key={number} className="page-item">
                        <a onClick={() => paginate(number)} href="#!" className="page-link">
                            {number}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

const HelpSupport = () => {
    const [tickets, setTickets] = useState([]);
    const [form, setForm] = useState({ subject: '', email: '', message: '', priority: 'Low' });
    const [attachment, setAttachment] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [notification, setNotification] = useState(null);
    const [comments, setComments] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const ticketsPerPage = 10;

    const { auth } = useContext(AuthContext);

    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://venusresume.vercel.app/';

    useEffect(() => {
        const fetchTickets = async () => {
            setIsLoading(true);
            try {
                const response = await axiosInstance.get('/api/support', {
                    headers: { Authorization: `Bearer ${auth.token}` }
                });
                setTickets(response.data);

                const userResponse = await axiosInstance.get('/api/users', {
                    headers: { Authorization: `Bearer ${auth.token}` }
                });
                setIsAdmin(userResponse.data.isAdmin);
            } catch (error) {
               // console.error('Error fetching support tickets', error);
                setNotification({ message: 'Error fetching support tickets', isError: true });
            } finally {
                setIsLoading(false);
            }
        };
        fetchTickets();
    }, [auth.token]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleFileChange = (e) => {
        setAttachment(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axiosInstance.post('/api/support', form, {
                headers: { Authorization: `Bearer ${auth.token}` }
            });
            const newTicket = response.data;

            if (attachment) {
                const formData = new FormData();
                formData.append('attachment', attachment);
                await axiosInstance.post(`/api/support/${newTicket.id}/attachment`, formData, {
                    headers: {
                        Authorization: `Bearer ${auth.token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                });
            }

            setTickets([...tickets, newTicket]);
            setForm({ subject: '', email: '', message: '', priority: 'Low' });
            setAttachment(null);
            setNotification({ message: 'Ticket submitted successfully', isError: false });
        } catch (error) {
           // console.error('Error submitting support ticket', error);
            setNotification({ message: 'Error submitting support ticket', isError: true });
        }
    };

    const handleStatusChange = async (ticketId, newStatus) => {
        try {
            const response = await axiosInstance.put('/api/support', { id: ticketId, status: newStatus }, {
                headers: { Authorization: `Bearer ${auth.token}` }
            });
            const updatedTicket = response.data;
            setTickets(tickets?.map(ticket => ticket.id === updatedTicket.id ? updatedTicket : ticket));
            setNotification({ message: 'Ticket status updated successfully', isError: false });
        } catch (error) {
           // console.error('Error updating support ticket status', error);
            setNotification({ message: 'Error updating support ticket status', isError: true });
        }
    };

    const handleAddComment = async (ticketId, comment) => {
        try {
            const response = await axiosInstance.post(`/api/support/${ticketId}/comment`, { comment: `Client Message: ${comment}` }, {
                headers: { Authorization: `Bearer ${auth.token}` }
            });
            const updatedTicket = response.data;
            setTickets(tickets?.map(ticket => ticket.id === updatedTicket.id ? updatedTicket : ticket));
            setNotification({ message: 'Comment added successfully', isError: false });
            setComments({ ...comments, [ticketId]: '' });
        } catch (error) {
           // console.error('Error adding comment', error);
            setNotification({ message: 'Error adding comment', isError: true });
        }
    };

    const handleCommentChange = (e, ticketId) => {
        setComments({ ...comments, [ticketId]: e.target.value });
    };

    const indexOfLastTicket = currentPage * ticketsPerPage;
    const indexOfFirstTicket = indexOfLastTicket - ticketsPerPage;
    const currentTickets = tickets.slice(indexOfFirstTicket, indexOfLastTicket);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const filteredTickets = tickets.filter(ticket =>
        (ticket?.subject?.toLowerCase().includes(searchTerm?.toLowerCase()) || ticket?.message?.toLowerCase().includes(searchTerm?.toLowerCase())) &&
        (filterStatus ? ticket.status === filterStatus : true)
    );

    return (
        <div className="help-support-container">
            {notification && (
                <Notification
                    message={notification.message}
                    isError={notification.isError}
                    onClose={() => setNotification(null)}
                />
            )}
            <h2>Help & Support</h2>
            <p>If you need assistance, please contact our support team at <a href="mailto:support@example.com">info@venus-online-software-training.com</a>.</p>

            {isAdmin ? (
                <AdminTicketManagement />
            ) : (
                <>
                    <div className="support-section">
                        <h3>Frequently Asked Questions</h3>
                        <ul>
                            <li>How can I reset my password?</li>
                            <li>How do I update my profile information?</li>
                            <li>Where can I find my order history?</li>
                            <li>What is the return policy?</li>
                        </ul>
                    </div>

                    <div className="support-section">
                        <h3>Live Chat</h3>
                        <p>Chat with one of our support agents for immediate assistance.</p>
                        <button className="live-chat-button">Start Live Chat</button>
                    </div>

                    <div className="support-section">
                        <h3>Contact Form</h3>
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <label>
                                Subject:
                                <input type="text" name="subject" value={form.subject} onChange={handleInputChange} required />
                            </label>
                            <label>
                                Email:
                                <input type="email" name="email" value={form.email} onChange={handleInputChange} required />
                            </label>
                            <label>
                                Message:
                                <textarea name="message" value={form.message} onChange={handleInputChange} required></textarea>
                            </label>
                            <label>
                                Priority:
                                <select name="priority" value={form.priority} onChange={handleInputChange} required>
                                    <option value="Low">Low</option>
                                    <option value="Medium">Medium</option>
                                    <option value="High">High</option>
                                </select>
                            </label>
                            {/* <label>
                                Attach Files:
                                <input type="file" name="attachment" onChange={handleFileChange} />
                            </label> */}
                            <button type="submit">Submit</button>
                        </form>
                    </div>

                    <div className="support-section">
                        <h3>Your Support Tickets</h3>
                        <input
                            type="text"
                            className="search-field"
                            placeholder="Search tickets"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <select className="filter-select" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                            <option value="">All Statuses</option>
                            <option value="open">Open</option>
                            <option value="closed">Closed</option>
                        </select>
                        {isLoading ? (
                            <div className="loading">
                                <div className="loader-container" style={{ marginTop: '30vh' }}>
                                    <ResumeSkeleton/>
                                </div>

                            </div>
                        ) : (
                            <>
                                {filteredTickets.length === 0 ? (
                                    <p>No support tickets found.</p>
                                ) : (
                                    <ul className="tickets-list">
                                        {filteredTickets?.slice(indexOfFirstTicket, indexOfLastTicket).map(ticket => {
                                            const attachmentUrl = (ticket.attachments && ticket.attachments.length > 0) ? `${baseUrl}${ticket.attachments[0].fileUrl}` : null;
                                            const placeholderUrl = `${baseUrl}/support/placeholder-image.jpg`;
                                            return (
                                                <li key={ticket.id} className="ticket-item">
                                                    <h4>{ticket.subject}</h4>
                                                    <p>{ticket.message}</p>
                                                    {attachmentUrl && (
                                                        <p><a href={attachmentUrl} target="_blank" rel="noopener noreferrer">View Attachment</a></p>
                                                    )}
                                                    <p>Status: {ticket.status}</p>
                                                    <div className="comments-section">
                                                        <h5>Comments:</h5>
                                                        <ul>
                                                            {ticket?.comments?.map((comment, index) => (
                                                                <li key={index}>{comment.comment} - {format(new Date(comment.createdDate), 'PPpp')}</li>
                                                            ))}
                                                        </ul>
                                                        <form onSubmit={(e) => {
                                                            e.preventDefault();
                                                            handleAddComment(ticket.id, comments[ticket.id] || '');
                                                        }}>
                                                            <input
                                                                type="text"
                                                                className="comment-field"
                                                                placeholder="Add a comment"
                                                                value={comments[ticket.id] || ''}
                                                                onChange={(e) => handleCommentChange(e, ticket.id)}
                                                            />
                                                            <button type="submit" className="comment-button">Add Comment</button>
                                                        </form>
                                                    </div>
                                                    <button className="status-button" onClick={() => handleStatusChange(ticket.id, ticket.status === 'open' ? 'closed' : 'open')}>
                                                        {ticket.status === 'open' ? 'Close Ticket' : 'Reopen Ticket'}
                                                    </button>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}
                                <Pagination
                                    ticketsPerPage={ticketsPerPage}
                                    totalTickets={filteredTickets.length}
                                    paginate={paginate}
                                />
                            </>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default HelpSupport;
